export default "__VITE_ASSET__382l1se0__"